import { AxiosInstance } from 'axios';

import { ExpandPromiseResponse, ObjectStrings } from '@sv-support-sdk/shared-types/src/common/utils';

interface IChatCheckRequest {
  user_id?: string;
  user_name?: string;
  uuid?: string;
  company_id?: number;
  fp?: string;
  chat_id?: number;
}

interface ChatSettingsResponse {
  data: {
    isOnline: boolean;
    isMaintenance: boolean;
    maintenanceMessage?: string;
  };
}

interface ChatBanResponse {
  ban: boolean;
}

export default (api: AxiosInstance, supportBackendApi: AxiosInstance) => ({
  checkChat: (params: IChatCheckRequest) => api.get('check', { params }),
  checkChatSettings: <T>(): ExpandPromiseResponse<ChatSettingsResponse, T> =>
    supportBackendApi.get('chats/settings'),
  checkForBan: <T>(data?: ObjectStrings): ExpandPromiseResponse<ChatBanResponse, T> => api.post('checkForBan', data),
});
